export type accessTokenResponseType = {
  access_token: string;
  expires_in: number;
  token_type: "Bearer";
};

/**
 * @ignore
 * Retrieves an access token from the specified OAuth2 token endpoint using client credentials.
 * Access tokens obtained this way are used to authenticate the client to access protected resources.
 *
 * It's crucial to
 * treat the client_secret like a password. Avoid using it in client-side
 * environments where it could be exposed through source code or developer
 * tools. Reserve its use for server-side operations, especially in token
 * generation, for enhanced security.
 *
 * @param {string} url - The URL of the OAuth2 token endpoint.
 * @param {string} client_id - The client ID for authentication.
 * @param {string} client_secret - The client secret for authentication.
 * @returns {Promise<accessTokenResponseType>} A Promise that resolves with the access token response.
 */
export async function getAccessToken(
  url: string,
  client_id: string,
  client_secret: string
): Promise<accessTokenResponseType> {
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams({
      grant_type: "client_credentials",
      client_id: client_id,
      client_secret: client_secret,
    }),
  });

  return res.json();
}

export async function getAccessTokenFromLocalhost(): Promise<accessTokenResponseType> {
  return (await fetch("http://localhost:8000")).json();
}
